import { SEGMENT_SPEND_GROUP_OPTIONS, type SpendGroupKind } from '@/domains/pages/ai-spend/constants';

const segmentSpendGroupKinds = new Set<SpendGroupKind>(SEGMENT_SPEND_GROUP_OPTIONS.map((option) => option.value));

export function resolveSegmentSpendGroup(value: SpendGroupKind): SpendGroupKind {
  if (segmentSpendGroupKinds.has(value)) {
    return value;
  }
  return 'task';
}
